import apiVersion from '@/api/ecommerce/mobileVersion';

const defaultState = () => ({
	listVersion: [],
});

const state = defaultState();

const getters = {

};

const mutations = {
	setVersion(state, data) {
		state.listVersion = data
	},
	clearDataVersion(state) {
		Object.assign(state, defaultState())
	}
};

const actions = {
	getVersion({ commit, dispatch }, params) {
		apiVersion.getDataVersion(params).then(({ data: { data } }) => {
			commit('setVersion', data.results);
		}).catch((err) => {
			commit('setVersion', []);
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
	},
	async updateVersion({ dispatch }, params) {
		await dispatch('isAttempting', null, { root: true })
		await apiVersion.updateVersion(params).then(res => {
			const data = res.data;
			dispatch('success', data.message, { root: true })
		}).catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
		await dispatch('attempted', null, { root: true })
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};